<template>
    <TableLayout :permissions="['renthouse:rhhousedeviceconfig:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="设备名称" prop="deviceName">
                <el-input v-model="searchForm.deviceName" placeholder="请输入设备名称" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['renthouse:rhhousedeviceconfig:create']">
                <li><el-button type="primary" @click="$refs.operaRhHouseDeviceConfigWindow.open('新建房屋设备')" icon="el-icon-plus" v-permissions="['renthouse:rhhousedeviceconfig:create']">新建</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
            >
                <el-table-column prop="deviceName" label="设备名称" min-width="100px"></el-table-column>
                <el-table-column label="设别图标" min-width="100px">
                    <template slot-scope="{row}">
                        <el-image
                            style="width: 80px; height: 80px"
                            :src="baseUrl + row.deviceIcon"
                            fit="cover" />
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="100px"></el-table-column>
                <el-table-column
                    v-if="containPermissions(['renthouse:rhhousedeviceconfig:update', 'renthouse:rhhousedeviceconfig:delete'])"
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" @click="$refs.operaRhHouseDeviceConfigWindow.open('编辑房屋设备', row)" icon="el-icon-edit" v-permissions="['renthouse:rhhousedeviceconfig:update']">编辑</el-button>
                        <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['renthouse:rhhousedeviceconfig:delete']">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaRhHouseDeviceConfigWindow ref="operaRhHouseDeviceConfigWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaRhHouseDeviceConfigWindow from '@/components/rentHouse/OperaRhHouseDeviceConfigWindow'
export default {
  name: 'RhHouseDeviceConfig',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaRhHouseDeviceConfigWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        deviceName: ''
      },
      baseUrl: process.env.VUE_APP_API_IMG
    }
  },
  created () {
    this.config({
      module: '房屋设备',
      api: '/rentHouse/rhHouseDeviceConfig',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
